import { Routes, Route } from 'react-router-dom';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import Dashboard from './components/Dashboard';
import Teams from './components/Teams';
import TeamDetail from './components/TeamDetail';
import MemberDetail from './components/MemberDetail';
import AdminDashboard from './components/admin/AdminDashboard';
import PrivateRoute from './components/auth/PrivateRoute';
import AdminRoute from './components/auth/AdminRoute';
import EditTeam from './components/admin/EditTeam';
import MainLayout from './components/shared/MainLayout';
import Unauthorized from './components/Unauthorized';
import TeamRules from './components/TeamRules';
import ManageTeamMembers from './components/ManageTeamMembers';
import AgentManagement from './components/AgentManagement';
import SalesContentAgent from './components/SalesContentAgent';
import DistributionExplanationAgent from './components/DistributionExplanationAgent';
import ConfigurationAgent from './components/ConfigurationAgent';
import TeamAgents from './components/TeamAgents';
import Settings from './components/Settings';
import BillingSettings from './components/BillingSettings';
import BillingSetup from './components/BillingSetup';
import ManageAttributes from './components/ManageAttributes';
import AgentAttributes from './components/AgentAttributes';
import Analytics from './components/Analytics';
import Faq from './components/Faq';
import Caps from './components/Caps';
import PortalSettings from './components/PortalSettings';
import ManageCustomObjects from './components/ManageCustomObjects';
import ExternalSystems from './components/ExternalSystems';
import MemberCaching from './components/MemberCaching';


export default function AppRoutes() {
  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/teams"
          element={
            <PrivateRoute>
              <Teams />
            </PrivateRoute>
          }
        />
        <Route
          path="/agents"
          element={
            <PrivateRoute>
              <AgentManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/agents/sales-content"
          element={
            <PrivateRoute>
              <SalesContentAgent />
            </PrivateRoute>
          }
        />
        <Route
          path="/agents/distribution-explanation"
          element={
            <PrivateRoute>
              <DistributionExplanationAgent />
            </PrivateRoute>
          }
        />
        <Route
          path="/agents/configuration"
          element={
            <PrivateRoute>
              <ConfigurationAgent />
            </PrivateRoute>
          }
        />
        <Route
          path="/team-agents"
          element={
            <PrivateRoute>
              <TeamAgents />
            </PrivateRoute>
          }
        />
        <Route
          path="/agent-attributes/:memberId"
          element={
            <PrivateRoute>
              <AgentAttributes />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/billing"
          element={
            <PrivateRoute>
              <BillingSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/billing/setup"
          element={
            <PrivateRoute>
              <BillingSetup />
            </PrivateRoute>
          }
        />
        <Route
          path="/faq"
          element={
            <PrivateRoute>
              <Faq />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/attributes"
          element={
            <PrivateRoute>
              <ManageAttributes />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/portal"
          element={
            <PrivateRoute>
              <PortalSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/custom-objects"
          element={
            <PrivateRoute>
              <ManageCustomObjects />
            </PrivateRoute>
          }
        />
        <Route
          path="/member-caps"
          element={
            <PrivateRoute>
              <Caps />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/caps"
          element={
            <PrivateRoute>
              <Caps />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/external-caps"
          element={
            <PrivateRoute>
              <Caps />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/external-systems"
          element={
              <PrivateRoute>
                  <ExternalSystems />
              </PrivateRoute>
          }
        />
        <Route
          path="/settings/member-caching"
          element={
            <PrivateRoute>
              <MemberCaching />
            </PrivateRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <PrivateRoute>
              <Analytics />
            </PrivateRoute>
          }
        />
        <Route
          path="/teams/:id"
          element={
            <PrivateRoute>
              <TeamDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/teams/:id/members/:memberId"
          element={
            <PrivateRoute>
              <MemberDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/teams/:id/rules"
          element={
            <PrivateRoute>
              <TeamRules />
            </PrivateRoute>
          }
        />
        <Route
          path="/teams/:id/manage-members"
          element={
            <PrivateRoute>
              <ManageTeamMembers />
            </PrivateRoute>
          }
        />
        <Route
          path="/memberdetail/:memberId"
          element={
            <PrivateRoute>
              <MemberDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/teams/:id/edit"
          element={
            <PrivateRoute>
              <AdminRoute>
                <EditTeam />
              </AdminRoute>
            </PrivateRoute>
          }
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </MainLayout>
  );
}
